const SecurityIcon = ({ size = 24, className = "", ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M16.65 5.95673C16.631 5.51827 16.631 5.09973 16.631 4.6812C16.631 4.34238 16.3848 4.08329 16.0627 4.08329C13.6946 4.08329 11.8948 3.3658 10.3982 1.83117C10.1709 1.61194 9.82984 1.61194 9.60251 1.83117C8.10586 3.3658 6.3061 4.08329 3.938 4.08329C3.61594 4.08329 3.36965 4.34238 3.36965 4.6812C3.36965 5.09973 3.36965 5.51827 3.35071 5.95673C3.27493 10.1421 3.16126 15.882 9.8109 18.2936L10.0003 18.3334L10.1898 18.2936C16.8205 15.882 16.7258 10.162 16.65 5.95673ZM9.54567 11.7564C9.432 11.8561 9.29939 11.9159 9.14783 11.9159H9.12888C8.97733 11.9159 8.82577 11.8362 8.73104 11.7166L6.96917 9.66376L7.82169 8.86655L9.20466 10.4809L12.2737 7.41164L13.0505 8.28857L9.54567 11.7564Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SecurityIcon; 